import React, { useEffect, useState } from "react";

import { coursesApi as courses } from "api";

// Reminds a visitor who clicked "Enroll" which class they will land in
// once they log in or sign up.
export default function JoiningBanner({ classId, action }) {
  const [course, setCourse] = useState(null);

  useEffect(() => {
    courses
      .details(classId)
      .then((data) => setCourse(data))
      .catch(() => {});
  }, [classId]);

  return (
    <div className="yc-joining">
      {course?.thumbnail && <img src={course.thumbnail} alt="" />}
      <p>
        {action} to join <strong>{course?.name ?? "your class"}</strong>
        {course?.type === "free" && " for free"}. We&apos;ll take you straight there.
      </p>
    </div>
  );
}
